import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { formatIsoDate, addDays } from '../../../Helpers/dateFormatter';
import TrackerQuery from './TrackerQuery';

interface ITrackerCacheConnectorApolloProps {
  children: (data: any) => React.ReactNode;
  date: any;
}

const TrackerCacheConnectorApollo: React.FC<ITrackerCacheConnectorApolloProps> = ({
  children,
  date,
}) => {
  const client = useApolloClient();
  const requestIdleCallbackIds: number[] = [];

  useEffect(() => {
    return () => {
      if (window.cancelIdleCallback) {
        requestIdleCallbackIds.forEach((id) => {
          window.cancelIdleCallback(id);
        });
      }
    };
  }, []);

  const idle = (callback: any) => {
    if (!window.requestIdleCallback) {
      callback();
      return;
    }
    requestIdleCallbackIds.push(window.requestIdleCallback(callback));
  };

  const createFetch = () => {
    const cacheDayIndex = [1, -1, 2, 3];

    cacheDayIndex.forEach((dayIndex) => {
      idle(() =>
        client.query({
          query: TrackerQuery,
          variables: {
            date: formatIsoDate(addDays(date, dayIndex)),
          },
          fetchPolicy: 'cache-first',
        })
      );
    });
  };

  return children({
    prefetchSurroundingDays: () => createFetch(),
  });
};

export default TrackerCacheConnectorApollo;
